import { render, staticRenderFns } from "./sbIndex.vue?vue&type=template&id=465c370e&"
import script from "./sbIndex.vue?vue&type=script&lang=js&"
export * from "./sbIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports